var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.7,275.8c-4.4,0-8.7-1.6-11.9-4.6l-40.9-37.8h-10.5c-6.3,0-11.3-5.1-11.3-11.3c0-6.3,5.1-11.3,11.3-11.3 h14.9c2.9,0,5.6,1.1,7.7,3l35.3,32.6v-93.9l-34.8,32.2c-2.1,1.9-4.8,3-7.7,3h-15.3c-6.3,0-11.3-5.1-11.3-11.3s5.1-11.3,11.3-11.3 h10.9l40.5-37.4c4.8-4.5,12-5.9,18.2-3.4c6.6,2.6,10.9,8.7,10.9,15.7V259c0,7-4.3,13.1-10.9,15.7 C282,275.4,279.9,275.8,277.7,275.8z M281.2,254.5L281.2,254.5C281.2,254.5,281.2,254.5,281.2,254.5z M281.2,144.2L281.2,144.2 C281.2,144.2,281.2,144.2,281.2,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.8,284.4H39c-18.8,0-34-15.3-34-34v-102c0-18.8,15.3-34,34-34h143.8c18.8,0,34,15.3,34,34v102 C216.8,269.1,201.5,284.4,182.8,284.4z M39,137c-6.3,0-11.3,5.1-11.3,11.3v102c0,6.2,5.1,11.3,11.3,11.3h143.8 c6.3,0,11.3-5.1,11.3-11.3v-102c0-6.2-5.1-11.3-11.3-11.3H39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,101.1c-23.6,0-42.7-19.2-42.7-42.7s19.2-42.7,42.7-42.7c23.6,0,42.7,19.2,42.7,42.7 S82.4,101.1,58.9,101.1z M58.9,27C41.6,27,27.5,41,27.5,58.4s14.1,31.4,31.4,31.4c17.3,0,31.4-14.1,31.4-31.4S76.2,27,58.9,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.6,101.1c-23.6,0-42.7-19.2-42.7-42.7s19.2-42.7,42.7-42.7s42.7,19.2,42.7,42.7S187.1,101.1,163.6,101.1z  M163.6,27c-17.3,0-31.4,14.1-31.4,31.4s14.1,31.4,31.4,31.4c17.3,0,31.4-14.1,31.4-31.4S180.9,27,163.6,27z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendar);
export default __webpack_public_path__ + "static/media/agendar.0f7aaa887dd782094b48c1ec2c6c60dc.svg";
export { ForwardRef as ReactComponent };